import { PageTitle } from '../components/PageShell';
import CallButton from '../components/CallButton';
import HelpBox from '../components/HelpBox';

export default function PolicyLayout({ title, updated, intro, children }) {
  return (
    <article className="policy">
      <PageTitle title={title} crumbs={[{ label: title }]} />
      {updated ? <p className="entry-meta">Last updated: {updated}</p> : null}
      {intro ? <p className="policy__intro">{intro}</p> : null}
      <CallButton />
      <div className="policy__body">{children}</div>
      <HelpBox
        title="Unsure About Anything Here?"
        text="Ask us. A member of our team can explain any part of this page by phone or live chat."
      />
    </article>
  );
}
